// SCSSをインポートしてSource Mapを生成
import "../scss/style.scss";

// import {
//   initGreeting
// } from './_modules/greeting.js';
import { initGlobalNav } from './_modules/globalNav.js';
import { initBusinessSwiper } from './_modules/businessSwiper.js';
import initTopHeroVideo from './_modules/topHeroVideo.js';
// import initTopHeroAnimation from './_modules/topHeroAnimation.js';
// import initTopIntro from './_modules/topIntro.js';
import initTopScrollAnimation from './_modules/topScrollAnimation.js';

function ensureHashScroll() {
	const rawHash = window.location.hash;
	if (!rawHash || rawHash === '#') return;

	const targetId = decodeURIComponent(rawHash.slice(1));
	if (!targetId) return;

	const scrollToTarget = () => {
		const target = document.getElementById(targetId);
		if (!target) return;

		// Native anchor jump may fail after cross-page navigation, so run only as a fallback.
		const distance = Math.abs(target.getBoundingClientRect().top);
		if (distance > 16) {
			target.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	};

	requestAnimationFrame(scrollToTarget);
	window.addEventListener('load', scrollToTarget, { once: true });
	setTimeout(scrollToTarget, 500);
}

document.addEventListener("DOMContentLoaded", () => {
	// console.log('Main JavaScript loaded successfully!');
	// initGreeting();
	initGlobalNav();
	initBusinessSwiper();
	initTopHeroVideo();
	// initTopHeroAnimation();
	// initTopIntro();
	initTopScrollAnimation();
	ensureHashScroll();
});
